export function resolveAnnotationSessionEndpoint(environment) {
  return environment.REACT_APP_ANNOTATION_SESSION_ENDPOINT
    || environment.REACT_APP_AWS_LAMBDA_ENDPOINT;
}
